import * as ng from 'angular';
import { BaseUrlService } from './base-url.service';
import { storageBaseUrl } from '../app.constants';

export class DropboxSaverService {
    static $inject: string[] = ['$http', '$rootScope', 'store'];

    private options: any;

    constructor(
        private $http: ng.IHttpService,
        private $rootScope: any,
        private store: ng.a0.storage.IStoreService
    ) {
        this.options = {};
    }

    setOptionsFiles(files: any) {
        let optionsFiles = [];
        let baseUrl = this.getStorageBaseUrl();
        let token = this.store.get('_GoogleAccessToken');

        ng.forEach(files, (value, key) => {
            let file = {
                'url': baseUrl + value.storage_path.split(' ').join('%20') + '?access_token=' + token,
                'filename': 'ArchiSMALL/' + value.name.split(' ').join('%20')
            };

            optionsFiles.push(file);
        });

        this.options.files = optionsFiles;

        return this.options.files;
    }

    getOptionsFiles() {
        return this.options.files;
    }

    setSuccessCallback(successCallback: any) {
        this.options.success = successCallback;
    }

    setProgressCallback(progressCallback: any) {
        this.options.progress = progressCallback;
    }

    setCancelCallback(cancelCallback: any) {
        this.options.cancel = cancelCallback;
    }

    setErrorCallback(errorCallback: any) {
        this.options.error = errorCallback;
    }

    getStorageBaseUrl() {
        return storageBaseUrl;
    }

    uploadFile(files: any) {
        let reader = new FileReader();
        let data;
        let isIE = (FileReader.prototype.readAsBinaryString === undefined);

        if (!isIE) {
            reader.readAsBinaryString(files);
        } else {
            reader.readAsArrayBuffer(files);
        }
        var readerResult: any = reader.result;
        if (!isIE) {
            data = btoa(readerResult);
        } else {
            let binary = '';
            let bytes = new Uint8Array(readerResult);
            let length = bytes.byteLength;
            for (let i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
            }

            data = btoa(binary);
        }

        this.$http({
            method: 'PUT',
            url: 'https://api-content.dropbox.com/1/files_put/dropbox/' + files[0].name + '?access_token=TOKEN',
            data: data
        })
            .then((response) => {
                // ?
            }, (error) => {
                // ?
            });
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/dropbox-saver.service.ts